import "./dnfLabel.css";

const DnfLabel = () => {
  return (
    <div className="dnf-label">DNF</div>
  );
};

export default DnfLabel;
